// Fallback del <Suspense> de las rutas con carga diferida (React.lazy).
//
// A propósito NO es SplashScreen: ése decide el destino según el token y
// navega, y un fallback se monta y desmonta sin avisar.
export default function RouteFallback() {
  return (
    <div
      role="status"
      aria-label="Cargando"
      className="flex h-screen w-full items-center justify-center bg-card"
    >
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-line border-t-transparent" />
    </div>
  );
}
